import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../../utils/auth";
const AdminLoginGuard = ({ children }) => {
  return isAuthenticated() ? <Navigate to="/admin/dashboard" /> : children;
};

export default AdminLoginGuard;
